import { useEffect, useState } from "react";
import axios from "axios";
import { configState } from "../lib/State";
import send_webview_data from "../lib/send_webview_data";
import Swal from "sweetalert2";
import { Dialog } from "@mui/material";

export default function ResearchInfo({ login }) {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const init = async () => setShow(await getData());
    init();
  }, [login]);

  const getData = async () => {
    const result = await axios.post(configState.api + "/gympass/get_research", {
      mid: login.mcd,
    });
    if (!result?.data?.success) return false;
    return true;
  };

  const goResearch = async () => {
    const agree = await Swal.fire({
      title: "설문조사에 참여 하시겠습니까?",
      icon: "question",
      showCancelButton: true,
      cancelButtonText: "다음에 할래요",
      confirmButtonText: "참여하기"
    });
    if (!agree.isConfirmed) return;
    const result = await getData();
    if (!result)
      return Swal.fire({
        icon: "error",
        title: "알림",
        text: "이미 설문조사에 참여 하셨습니다.",
      });
    const url = `https://tally.so/r/waGVzX?mid=${login.mcd}`;
    if (window.ReactNativeWebView === undefined) window.open(url);
    else
      send_webview_data({
        id: "open_url",
        value: url,
      });
    setOpen(true);
  };

  return (
    show && (
      <>
        <Dialog fullScreen open={open} onClose={() => setOpen(false)}>
          <section className="h-screen flex justify-center items-center flex-col">
            <p className="text-xl">설문조사를 완료하셨나요?</p>
            <p>참여 완료를 누르고 캐시를 받아보세요.</p>
            <button
              className="text-white bg-blue-400 px-3 py-2 rounded mt-5"
              onClick={() => window.location.reload()}
            >
              설문조사 참여 완료
            </button>
          </section>
        </Dialog>

        <button className="px-3 pt-3" onClick={goResearch}>
          <img src="/img/research_banner.png" alt="" className="rounded" />
        </button>
      </>
    )
  );
}
